import type { VoidFunctionComponent } from 'react';

type Props = {
  isSmallIcon?: boolean;
};

const FallbackIcon: VoidFunctionComponent<Props> = ({ isSmallIcon }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={isSmallIcon ? 12 : 16} height={isSmallIcon ? 12 : 16} fill="none" viewBox="0 0 80 80">
      <path
        fill="#71717B"
        d="M74.063 25.625A9.116 9.116 0 0 1 75 29.688V65c0 5.625-4.531 10-10 10H15C9.375 75 5 70.625 5 65V29.687c0-1.406.156-2.812.781-4.062l6.563-14.531C13.906 7.344 17.5 5 21.406 5h37.032c3.906 0 7.5 2.344 9.062 6.094l6.563 14.531ZM50 25h15.625l-4.844-10.938c-.468-.937-1.406-1.562-2.343-1.562H45.78L50 25ZM34.062 12.5H21.407c-.937 0-1.875.625-2.343 1.563L14.218 25h15.625l4.218-12.5ZM30 32.5H12.5V65c0 1.406 1.094 2.5 2.5 2.5h50c1.25 0 2.5-1.094 2.5-2.5V32.5H50V40c0 2.813-2.344 5-5 5H35c-2.813 0-5-2.188-5-5v-7.5Z"
      />
    </svg>
  );
};

export default FallbackIcon;
